import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, perfixLineColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import { useHistory } from "react-router-dom";
import PCIADialog from "../../CIA/PCIADialog.js";
import { ciaCameraNameInfo } from "../../../service/CIA/CiaService";
//CSS
import "../../../components/DataTable/DataTable.css";


export default function P100List({ dataTable, searchData, newBill, goPage, setHandlerReport, setLoading, setErrData, showMessages, userId }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const history = useHistory();
    const [data, setData] = useState({});

    const [dialog, setDialog] = useState({
        open: false,
        action: "",
    });

    const [dataSet, setDataSet] = useState({});

    const headerLabel = <span className="hidden-responsive">เพิ่มใบแจ้งฯใหม่ </span>;
    const headerSrhLabel = <span className="hidden-responsive">ค้นหาใบแจ้งฯ </span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-plus"
                onClick={() => {
                    // setDialog({ dialog: true });
                    newBill();
                }}
            />
            <Button
                className="p-button btn-hidden-responsive span-responsive"
                label={headerSrhLabel}
                icon="pi pi-search"
                onClick={() => {
                    history.push({
                        pathname: "/108",
                        state: { dataSrh: searchData },
                    });
                }}
            />
        </div>
    );

    const printRequest = (data) => {
        setHandlerReport(data.requestNo);
    };

    const allaction = (rowData) => {
        let funId = rowData && rowData.functionId ? rowData.functionId : "";
        let buttonIcon = rowData && rowData.buttonIcon ? rowData.buttonIcon : "";
        let buttonTooltip = rowData && rowData.buttonTooltip ? rowData.buttonTooltip : "";
        let ciaCameraId = rowData && rowData.ciaCameraId ? rowData.ciaCameraId : "";
        let isDisabled = true,
            buttonShowIcon = "pi pi-pencil",
            btnClass = "btn-success";

        if (buttonIcon !== "") {
            switch (buttonIcon) {
                case "View": {
                    buttonShowIcon = "pi pi-eye";
                    btnClass = "p-button-help";
                    break;
                }

                // 05/02/2022
                // case 'Report' : {  buttonShowIcon = "pi pi-file"; btnClass ="p-button-secondary"; break;}
                case "Input": //{ break;}
                default:
                    break;
            }
        } else {
            isDisabled = false;
        }

        let labelEditShow = <span className="show-responsive">{buttonTooltip}</span>;
        let labelPrintShow = <span className="show-responsive">พิมพ์รายงาน</span>;

        const rowData_2 = { ...rowData, functionId: "120" };
        return (
            <>
                <React.Fragment>
                    <div style={{ textAlign: "center" }}>
                        {isDisabled && (
                            <Button
                                icon={buttonShowIcon}
                                // style={{ backgroundColor: "#1a6a37", border: "1px solid #1a6a37" }}
                                className={`p-button ${btnClass} btn-label-responsive btn-md-responsive p-mr-2 p-mb-2 `}
                                onClick={() => goPage(rowData)}
                                // disabled={isDisabled}
                                tooltip={buttonTooltip}
                                tooltipOptions={{ position: "top" }}
                                label={labelEditShow}
                            />
                        )}

                        {/* new 14/02/2022 <i class="fa-solid fa-clock-rotate-left"></i> */}
                        <Button
                            icon="fa fa-history"
                            // style={{ backgroundColor: "#1a6a37", border: "1px solid #1a6a37" }}
                            className={`p-button p-button-secondary btn-label-responsive btn-md-responsive p-mr-2 p-mb-2 `}
                            onClick={() => goPage(rowData_2)}
                            // disabled={isDisabled}
                            // tooltip={buttonTooltip}
                            // tooltipOptions={{ position: "top" }}
                            // label={labelEditShow}
                        />

                        {/* {isDisabledEdit &&
                            <Button
                                icon="pi pi-pencil"
                                style={{ backgroundColor: "#1a6a37", border: "1px solid #1a6a37" }}
                                className="p-button btn-label-responsive btn-md-responsive p-mr-2 p-mb-2"
                                onClick={() => goPage(rowData)}
                                // disabled={isDisabledEdit}
                                tooltip="คลิกเพื่อ แก้ไขข้อมูล"
                                tooltipOptions={{ position: "top" }}
                                label={labelEditShow}
                            />
                        }

                        {isDisabledReport &&
                            <Button
                                icon="pi pi-file"
                                className="p-button p-button-secondary btn-label-responsive btn-md-responsive p-mr-2 p-mb-2"
                                onClick={() => goPage(rowData)}
                                // disabled={isDisabledReport}
                                toolt
                                tooltip="คลิกเพื่อ รายงานผลฯ "
                                tooltipOptions={{ position: "top" }}
                                label={labelReportShow}
                            />
                        } */}

                        <Button icon="pi pi-print" className="p-button btn-label-responsive btn-md-responsive p-mr-2 p-mb-2" onClick={() => printRequest(rowData)} tooltip="คลิกเพื่อ พิมพ์รายงาน" tooltipOptions={{ position: "top" }} label={labelPrintShow} />
                        <Button icon="pi pi-folder" 
                        className="p-button-warning p-button btn-label-responsive btn-md-responsive p-mr-2 p-mb-2" 
                        onClick={() => onOpenDialog(rowData)} 
                        tooltip="ข้อมูลกล้องจากระบบ CIA" 
                        tooltipOptions={{ position: "top" }} 
                        disabled={ciaCameraId === "" ? true : false}/>
                    </div>
                </React.Fragment>
            </>
        );
    };

    const onOpenDialog = (data) => {
        onGetDataInfo(data);
        
    }

    const onGetDataInfo = async (data) => {
        setLoading(true);
        console.log("ciaCameraId we: ", data)
   
            let req = {
                cameraCode : data.ciaCameraId,
                userId: userId,
            };
    
            await ciaCameraNameInfo(req).then(
                (res) => {
                    setLoading(false);
                    console.log("dataList : ", res.data)
                    if (res.data !== null) {
                        setDialog({ open: true , action: "U"});
                        setDataSet(res.data);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
       
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card" style={{ padding: "0rem" }}>
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column sortable field="requestNo" header="เลขที่ใบแจ้งฯ" body={(e) => normalColumn(e, "requestNo", "เลขที่ใบแจ้งฯ")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNo", "เลขที่สัญญา")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="routeNo" header="เส้นทาง" body={(e) => normalColumn(e, "routeNo", "เส้นทาง")} style={{ textAlign: "center", width: "7%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="requestTypeDesc" header="ประเภทงาน" body={(e) => normalColumn(e, "requestTypeDesc", "ประเภทงาน")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="requestCaseDesc" header="ลักษณะงาน" body={(e) => perfixLineColumn(e, "requestCaseDesc", "ลักษณะงาน")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="requestLocation" header="บริเวณก่อสร้าง" body={(e) => normalColumn(e, "requestLocation", "บริเวณก่อสร้าง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="requestPeriod" header="ช่วงเวลาปฏิบัติงาน" body={(e) => normalColumn(e, "requestPeriod", "ช่วงเวลาปฏิบัติงาน")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="foreman" header="หัวหน้างาน" body={(e) => normalColumn(e, "foreman", "หัวหน้างาน")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="requestStatusDesc" header="สถานะใบแจ้งฯ" body={(e) => normalColumn(e, "requestStatusDesc", "สถานะใบแจ้งฯ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />

                    <Column header="" body={(e) => allaction(e)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>

            <PCIADialog dialog={dialog} setDialog={setDialog} dataSet={dataSet}></PCIADialog>
        </div>
    );
}
